import { useEffect } from 'react';
import classNames from 'classnames';
import styles from './styles.module.scss';
import { useAppDispatch, useAppSelector } from 'src/store/hooks';
import { shallowEqual } from 'react-redux';
import { SiteList } from 'src/components';
import { Skeleton } from '@mantine/core';
import { getDashbardsList, setSelectedCompanyofDashborad, setSelectedDashboard } from 'src/store';

export type dashboardType = {
  id: string,
  dashboardName: string,
  tenant_id: string
}

function getSiteListProps(data?: any) {
  if (!data) {
    return {
      accessibilityScoreProgress: null,
      complianceScore: 0,
      complianceLevel: '',
      description: '',
      criteriaPassed: 0,
      criteriaNotTested: 0,
      criteriaFailed: 0,
      issuesCountByPriority: {
        low: 0,
        medium: 0,
        warning: 0,
        high:0,
        critical:0
      },
      numberOfIssues: 0,
      closedIssues: 0,
      newsIssues: 0,
      openIssues: 0,
      commonIssues: {},
      commonSeccess: {},
      webSitesData: [],
      issuesCountOverTime: { actual: [] },
      ialabsScore: 0,
      showDefaultDash: true,
    };
  }

  return {
    accessibilityScoreProgress: data.accessibilityScoreProgress ?? null,
    complianceScore: data.complianceScore ?? 0,
    complianceLevel: data.complianceLevel ?? '',
    description: data.description ?? '',
    criteriaPassed: data.criteriaPassed ?? 0,
    criteriaNotTested: data.criteriaNotTested ?? 0,
    criteriaFailed: data.criteriaFailed ?? 0,
    issuesCountByPriority: data.issuesCountByPriority,
    numberOfIssues: data.numberOfIssues,
    closedIssues: data.closedIssues,
    newsIssues: data.newIssues,
    openIssues: data.openIssues,
    commonIssues: data.commonIssues,
    commonSeccess: data.commonSeccess,
    webSitesData: data.webSitesData,
    issuesCountOverTime: data.issuesCountOverTime,
    ialabsScore: data.ialabsScore,
  };
}

const DashboardPage = (): JSX.Element => {
  const { company_id } = useAppSelector((state) => state.user.data, shallowEqual);
  const { dashboard, setSelectedCompany, loadingSetSelectedCompany } = useAppSelector((state) => state.dashboardCharts, shallowEqual);

  const dispatch = useAppDispatch();
  useEffect(() => {
    if (company_id) {
      dispatch(setSelectedCompanyofDashborad({ company_id: setSelectedCompany?.company_id ??   company_id }))
      dispatch(getDashbardsList({
        submitCallback: () => {
          dispatch(setSelectedDashboard({ dashboard_id: dashboard?.id })) // get the cached dashboard and set it as default.
        },
        errorCallback: (msg: string) => {
          console.log(`Enable to get dashboard list: ${msg}`);
        }
      }))
    }
  }, [company_id]);
  return (
    <main className={classNames(styles['main-container'])}>

      {loadingSetSelectedCompany ? (
        <div className={styles['grid-cols-2']}>
          {Array.from({ length: 8 }).map((_, index) => (
            <div key={index}>
              <Skeleton width="200px" height="200px" circle mb="xl" mx="auto" />
              <Skeleton height={8} radius="xl" />
              <Skeleton height={8} mt={6} radius="xl" />
              <Skeleton height={8} mt={6} width="70%" radius="xl" />
            </div>
          ))}
        </div>
      ) : (
        <SiteList {...getSiteListProps(setSelectedCompany)} />
      )}
    </main>

  );
};

export default DashboardPage;
